import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useState } from 'react'
import { DialogClose } from '@/components/DialogClose/DialogClose'
import { enableCurrentDeviceNotifications } from '../../browserPush'
import styles from './NotificationSetupPrompt.module.scss'

export function NotificationSetupPrompt({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const enable = async () => {
    setSaving(true); setError(null)
    try { await enableCurrentDeviceNotifications(); onClose() }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Notifications could not be enabled.') }
    finally { setSaving(false) }
  }
  const later = () => onClose()
  return <Dialog open={open} onClose={saving ? undefined : later} fullWidth maxWidth="xs">
    <DialogTitle>Turn on push notifications?<DialogClose onClose={saving ? () => undefined : later} /></DialogTitle>
    <DialogContent>
      <NotificationsActiveOutlinedIcon color="primary" fontSize="large" />
      <Typography className={styles.lead}>When your session lead sends an update, you’ll get a push notification on this device’s lock screen, even when OutreachOS is closed.</Typography>
      <Typography className={styles.detail} color="text.secondary" variant="body2">Your browser will then ask you to allow notifications. You can change this any time under Push notifications in the menu.</Typography>
      {error ? <Alert className={styles.error} severity="warning">{error}</Alert> : null}
    </DialogContent>
    <DialogActions><Button onClick={later} disabled={saving}>Not now</Button><Button variant="contained" onClick={() => void enable()} disabled={saving}>{saving ? 'Enabling…' : 'Enable push notifications'}</Button></DialogActions>
  </Dialog>
}
